import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@garnet/ui/styles/core.css';
import './app.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
